import { useQuery } from '@tanstack/react-query';
import { AlertApi } from '../../../apis/AlertApi/AlertApi';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { IClinicalAlert } from '../Alert';

export function usePatientAlerts() {
    return useQuery<IClinicalAlert[]>({
        queryKey: [QueryKeys.patientAlerts],
        queryFn: () => AlertApi.getPatientAlerts(),
    });
}
